module.exports = __webpack_public_path__ + "static/logo-3185c36058d84abb46887ad30a973270.png";